module.exports = __webpack_public_path__ + "assets/img/menu-notes.ea4459ef.svg";